import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SiteStore } from '@core/site/site.store';
import { BasketComponent } from '../basket/basket.component';

@Component({
  selector: 'app-drawer-basket',
  imports: [MatIconModule, MatButtonModule, BasketComponent],
  templateUrl: './drawer-basket.component.html',
  styleUrl: './drawer-basket.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawerBasketComponent {
  protected site = inject(SiteStore);
}
